import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import styled from "@emotion/styled";
import React from "react";
import VerticalLogo from "./components/Auth/components/VerticalLogo";
import { AppButton } from "./components/Generic/AppButton";
import ScaffoldTitle from "./components/Scaffold/components/ScaffoldTitle";
import Scaffold from "./components/Scaffold/Scaffold";
import { openExternalUrl } from "./external_link";
import { STRINGS } from "./strings";
import { translate } from "./translate";
import { AppVersion } from "./version";

export const OutdatedVersionScreen = () => {
  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.PLEASE_UPDATE_TO_OUR_NEWEST_VERSION)} />}
      onClickGoBack={() => App.exitApp()}
    >
      <OutdatedVersionScreen.Body>
        <VerticalLogo />
        <AppButton
          variant="soft"
          onClick={() =>
            openExternalUrl(
              Capacitor.getPlatform() === "ios"
                ? "https://itunes.apple.com/us/app/medflyt/id1165814775?mt=8"
                : "https://play.google.com/store/apps/details?id=com.medflyt.iphone"
            )
          }
        >
          {translate(STRINGS.CLICK_HERE_TO_DOWNLOAD)}
        </AppButton>

        <OutdatedVersionScreen.Version>
          {translate(STRINGS.MEDFLYT_VERSION)}: {AppVersion}
        </OutdatedVersionScreen.Version>
      </OutdatedVersionScreen.Body>
    </Scaffold>
  );
};

OutdatedVersionScreen.Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: 100%;
  padding: 32px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  ${VerticalLogo.Styled} {
    margin-top: auto;
  }
`;

OutdatedVersionScreen.Version = styled.div`
  margin-top: auto;
  color: var(--gray-500);
`;
